import { render, staticRenderFns } from "./EditorWalletNew.vue?vue&type=template&id=c907fb9e&scoped=true&"
import script from "./EditorWalletNew.vue?vue&type=script&lang=js&"
export * from "./EditorWalletNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c907fb9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c907fb9e')) {
      api.createRecord('c907fb9e', component.options)
    } else {
      api.reload('c907fb9e', component.options)
    }
    module.hot.accept("./EditorWalletNew.vue?vue&type=template&id=c907fb9e&scoped=true&", function () {
      api.rerender('c907fb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorWalletNew.vue"
export default component.exports